import { Stack, Box, Typography, Button } from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import { useTranslation } from "react-i18next";

interface SSMLViewBannerProps {
  isEditing: boolean;
  onStartEditing: () => void;
}

export const SSMLViewBanner = ({
  isEditing,
  onStartEditing,
}: SSMLViewBannerProps) => {
  const { t } = useTranslation();

  if (isEditing) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          p: 1.5,
          backgroundColor: "#FFF4E5",
        }}
      >
        <WarningAmberOutlined
          sx={{ color: "rgba(140, 102, 8, 1)", fontSize: 22 }}
        />
        <Typography
          variant="body2"
          color="rgba(140, 102, 8, 1)"
          sx={{ flex: 1 }}
        >
          {t("ssml.ssmlViewBanner.warningBanner")}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        p: 1.5,
        backgroundColor: "#E3F2FD",
      }}
    >
      <InfoOutlined sx={{ color: "info.main", fontSize: 22 }} />

      <Stack direction="row" alignItems="center" spacing={0.5} sx={{ flex: 1 }}>
        <Typography variant="body2">
          {t("ssml.ssmlViewBanner.infoBanner")}
        </Typography>
      </Stack>

      <Button
        variant="contained"
        size="small"
        sx={{
          backgroundColor: "#2196F3",
          textTransform: "none",
          fontSize: "14px",
          fontWeight: 500,
          "&:hover": {
            backgroundColor: "#1976D2",
          },
        }}
        onClick={onStartEditing}
        id="start-ssml-editing"
      >
        {t("buttons.startEditing")}
      </Button>
    </Box>
  );
};
